export default __webpack_public_path__ + "static/media/clareamento-mina.808e8efc.png";